<template>
  <header class="app-header">
    <div class="app-header__content-wrapper">
      <div class="app-header__content">
        <div class="app-header__main">
          <a class="app-header__brand" href="https://goingdigital.oecd.org">
            <img
              src="@/assets/images/ic_logo_oecd_40dp.svg"
            >
            <img
              src="@/assets/images/ic_logo_toolkit_58dp.png"
            >
          </a>
          <div class="app-header__burger">
            <div class="app-header__burger-button" @click="expanded = !expanded">
              <svg
                v-if="!expanded"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#ffffff"
                  fill-rule="evenodd"
                  d="M0 5h24v2H0zm0 6h24v2H0zm0 6h24v2H0z"
                />
              </svg>
              <svg
                v-else
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="#ffffff"
                  stroke-linecap="square"
                  stroke-width="2"
                  d="M20 20L4 4m0 16L20 4"
                />
              </svg>
            </div>
          </div>
        </div>
        <nav class="app-header__nav-menu app-header__col" :class="{ expanded: expanded }">
          <div class="app-header__external-links">
            <div>
              <a href="https://www.oecd.org">
                OECD
                <svg width="16" height="16" viewBox="0 0 16 16">
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M8 3v1H4v8h8V8h1v5H3V3h5zm5.004 0v3.536L11.59 5.12 7.347 9.364l-.707-.707 4.243-4.243L9.468 3h3.536z"
                  />
                </svg>
              </a>
              <a href="https://www.oecd.ai">
                OECD.AI
                <svg width="16" height="16" viewBox="0 0 16 16">
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M8 3v1H4v8h8V8h1v5H3V3h5zm5.004 0v3.536L11.59 5.12 7.347 9.364l-.707-.707 4.243-4.243L9.468 3h3.536z"
                  />
                </svg>
              </a>
              <a href="https://depp.oecd.org/">
                DPP
                <svg width="16" height="16" viewBox="0 0 16 16">
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M8 3v1H4v8h8V8h1v5H3V3h5zm5.004 0v3.536L11.59 5.12 7.347 9.364l-.707-.707 4.243-4.243L9.468 3h3.536z"
                  />
                </svg>
              </a>
              <a href="https://goingdigital.oecd.org/about">
                ABOUT
              </a>
            </div>
          </div>
          <div class="app-header__pages">
            <div>
              <a href="https://goingdigital.oecd.org">Home</a>
              <a href="https://goingdigital.oecd.org/dimensions">Policy Dimensions</a>
              <a href="https://goingdigital.oecd.org/countries">Countries</a>
              <a href="https://goingdigital.oecd.org/themes">Themes</a>
              <router-link
                class="active"
                :to="coverURL"
              >
                Data Kitchen
              </router-link>
              <a href="https://goingdigital.oecd.org/indicators">Indicators</a>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      expanded: false,
    }
  },
  computed: {
    coverURL() {
      const params = this.$route.params
      return `/cover/${params.version}/${params.versionName}/indicator/explore/${params.lng}`
    }
  },
  watch: {
    expanded(to) {
      if (to) {
        document.querySelector('#app').style.overflow = 'hidden'
        document.querySelector('#app').style.position = 'fixed'
        document.querySelector('#app').style.left = '0px'
        document.querySelector('#app').style.right = '0px'
        document.body.addEventListener("click", this.watchClicks)
      } else {
        document.querySelector('#app').style.overflow = null
        document.querySelector('#app').style.position = null
        document.querySelector('#app').style.left = null
        document.querySelector('#app').style.right = null
        document.body.removeEventListener("click", this.watchClicks)
      }
    },
  },
  methods: {
    watchClicks(ev) {
      if (!this.$el.contains(ev.target)) this.expanded = false;
    },
  }
}
</script>

<style lang="stylus">
.app-header
  background-color: #142f4e
  font-family: "Caecilia LT Pro", Georgia, sans

.app-header__content-wrapper
  height: 100%
  max-width: 1280px
  padding: 0 62px
  margin: auto

  @media screen and (max-width: 1440px)
    padding: 0 48px
    max-width: 1242px

  @media screen and (max-width: 1024px)
    padding: 0 24px
    max-width: 1204px

.app-header__content
  display: flex
  justify-content: space-between
  align-items: center
  margin: 0 -24px
  padding: 0 24px

.app-header__main
  flex: 1
  display: flex
  align-items: center
  justify-content: space-between
  z-index: 20
  background-color: #142f4e

.app-header__brand
  display: flex
  align-items: center
  z-index: 10

  img
    height: 40px

    @media screen and (max-width: 1024px)
      height: 26px

    + img
      margin-left: 16px
      height: 58px

      @media screen and (max-width: 1024px)
        margin-left: 12px
        height: 36px

.app-header__nav-menu
  z-index: 15
  display: flex
  align-items: flex-end
  flex-direction: column
  background-color: #142f4e

  @media screen and (max-width: 1024px)
    pointer-events: none
    opacity: 0
    position: absolute
    top: 0px
    left: 0px
    right: 0px
    padding: 84px 0px 40px
    transform: translateY(-150px)
    transition: transform 400ms ease 0s
    flex-flow: column-reverse

  &.expanded
    align-items: flex-start
    pointer-events: all
    opacity: 1
    transform: translateY(0px)

.app-header__external-links
  padding-top: 10px
  margin-right: -12px
  display: block

  @media screen and (max-width: 1024px)
    display: none
    padding-top: 0px

  > div
    display: flex

    @media screen and (max-width: 1024px)
      display: block
      margin-bottom: 40px

    > a
      display: inline-flex
      font-family: 'Bernini Sans', 'Helvetica Neue', Helvetica, Arial, serif
      font-size: 14px
      font-weight: 400
      line-height: 18px
      padding: 8px 12px
      color: rgba(255, 255, 255, .75)
      transition: color 120ms ease-in-out

      .expanded &
        display: flex

      &:hover
        color: rgba(255, 255, 255, 1)

      > svg
        margin: 0 0 2px 4px

  .expanded &
    display: block

.app-header__pages
  display: block

  @media screen and (max-width: 1024px)
    width: 100%

  > div
    display: block

    @media screen and (max-width: 1024px)
      margin-bottom: 40px

    > a
      position: relative
      font-family: "Caecilia LT Pro", Georgia, serif
      font-weight: 700
      display: inline-block
      padding: 8px 8px 18px
      color: rgba(255, 255, 255, .75)
      font-size: 16px
      line-height: 32px

      &.active
      &:hover
        color: #dcdf5a

        &:after
          opacity: 1

      &:after
        content: " "
        position: absolute
        bottom: 0px
        height: 4px
        left: 8px
        right: 8px
        background-color: #dcdf5a
        opacity: 0
        transition: opacity 120ms ease-in-out

      @media screen and (max-width: 1024px)
        display: block
        padding: 8px 24px

        &:after
          opacity: .25
          background-color: #ffffff
          height: 1px
          left: 24px
          right: 24px

        &.active:after
        &:hover:after
          opacity: .25

.app-header__burger
  margin-right: -24px

.app-header__nav-burger
  display: flex
  align-items: center
  margin-right: -24px
  z-index: 10

.app-header__burger-button
  height: 64px
  width: 72px
  align-items: center
  justify-content: center
  cursor: pointer
  padding: 20px 24px
  display: flex

  @media screen and (min-width: 1024px)
    display: none
</style>
